module.exports = __webpack_public_path__ + "img/1024.da52c6a3.svg";